import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { AppView, Button, ButtonGroup, StatusBar, rem } from 'design-system';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { IconArrowTurn } from 'design-system/icons/IconArrowTurn';
import { KYCDocumentType } from '../types';
const id = require('../img/id.png');
const residencePermit = require('../img/residence-permit.png');
const driversLicense = require('../img/drivers-licence.png');
const getText = (documentType) => {
    switch (documentType) {
        case KYCDocumentType.NATIONAL_ID: {
            return 'You’ll need to take a photo of the back of your ID next.';
        }
        case KYCDocumentType.DRIVING_LICENCE: {
            return 'You’ll need to take a photo of the back of your Drivers License next.';
        }
        case KYCDocumentType.UK_BIOMETRIC_RESIDENCE_PERMIT: {
            return 'You’ll need to take a photo of the back of your Residence Permit next.';
        }
        default: {
            return 'Make sure you have uploaded the entire document page and the details are clear to read with no blur or glare';
        }
    }
};
const BackDocumentSideUploadInstructionsScreen = ({ navigation, route, }) => {
    const flow = route.params?.flow;
    const photoFiles = route.params?.files;
    const documentType = route.params?.documentType;
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Turn the ID over',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const containerStyles = useMarginBottom('paddingBottom', undefined, styles.flex);
    const handleContinue = useCallback(() => {
        switch (documentType) {
            case KYCDocumentType.NATIONAL_ID:
            case KYCDocumentType.DRIVING_LICENCE:
            case KYCDocumentType.UK_BIOMETRIC_RESIDENCE_PERMIT: {
                navigation.navigateDeprecated('InvestScanDocument', { flow, documentType, photoFile: photoFiles[0] });
                break;
            }
            case KYCDocumentType.PASSPORT:
            default:
                navigation.popToTop();
                break;
        }
    }, [documentType, flow, photoFiles]);
    const img = useMemo(() => {
        switch (documentType) {
            case KYCDocumentType.NATIONAL_ID: {
                return id;
            }
            case KYCDocumentType.DRIVING_LICENCE: {
                return driversLicense;
            }
            case KYCDocumentType.UK_BIOMETRIC_RESIDENCE_PERMIT: {
                return residencePermit;
            }
            case KYCDocumentType.PASSPORT:
            default:
                return '';
        }
    }, [documentType]);
    return (<AppView avoidHeader>
      <StatusBar barStyle="dark-content" animated/>
      <View style={containerStyles}>
        <View style={styles.mainContainer}>
          <View style={styles.imageContainer}>
            <Image source={img} style={styles.image} resizeMode="cover"/>
          </View>
          <View style={styles.arrowContainer}>
            <IconArrowTurn />
          </View>
        </View>
        <View style={styles.textContainer}>
          <Text Text-16 centered>
            {getText(documentType)}
          </Text>
        </View>
        <ButtonGroup>
          <Button brand title="Take a photo" onPress={handleContinue}/>
        </ButtonGroup>
      </View>
    </AppView>);
};
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    mainContainer: {
        flex: 3,
    },
    textContainer: {
        flex: 2,
        paddingHorizontal: rem(16),
    },
    imageContainer: {
        flex: 1,
    },
    image: {
        width: '100%',
        height: '100%',
    },
    arrowContainer: {
        left: 0,
        right: 0,
        top: '16%',
        position: 'absolute',
        alignItems: 'center',
    },
});
export default BackDocumentSideUploadInstructionsScreen;
